/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetDealPipedriveContextRequest {
    companyId?: number;
    isShared?: boolean;
    resource?: string;
    selectedIds?: number;
    userId?: number;
    view?: string;
}

export interface GetPersonPipedriveContextRequest {
    companyId?: number;
    isShared?: boolean;
    resource?: string;
    selectedIds?: number;
    userId?: number;
    view?: string;
}

/**
 * WebhooksApi - interface
 * 
 * @export
 * @interface WebhooksApiInterface
 */
export interface WebhooksApiInterface {
    /**
     * 
     * @param {number} [companyId] 
     * @param {boolean} [isShared] 
     * @param {string} [resource] 
     * @param {number} [selectedIds] 
     * @param {number} [userId] 
     * @param {string} [view] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApiInterface
     */
    getDealPipedriveContextRaw(requestParameters: GetDealPipedriveContextRequest): Promise<runtime.ApiResponse<string>>;

    /**
     */
    getDealPipedriveContext(requestParameters: GetDealPipedriveContextRequest): Promise<string>;

    /**
     * 
     * @param {number} [companyId] 
     * @param {boolean} [isShared] 
     * @param {string} [resource] 
     * @param {number} [selectedIds] 
     * @param {number} [userId] 
     * @param {string} [view] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApiInterface
     */
    getPersonPipedriveContextRaw(requestParameters: GetPersonPipedriveContextRequest): Promise<runtime.ApiResponse<string>>;

    /**
     */
    getPersonPipedriveContext(requestParameters: GetPersonPipedriveContextRequest): Promise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApiInterface
     */
    logPipedrivePersonAddedRaw(): Promise<runtime.ApiResponse<string>>;

    /**
     */
    logPipedrivePersonAdded(): Promise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApiInterface
     */
    logPipedrivePersonDeletedRaw(): Promise<runtime.ApiResponse<string>>;

    /**
     */
    logPipedrivePersonDeleted(): Promise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApiInterface
     */
    logPipedrivePersonMergedRaw(): Promise<runtime.ApiResponse<string>>;

    /**
     */
    logPipedrivePersonMerged(): Promise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApiInterface
     */
    logPipedrivePersonUpdatedRaw(): Promise<runtime.ApiResponse<string>>;

    /**
     */
    logPipedrivePersonUpdated(): Promise<string>;

}

/**
 * 
 */
export class WebhooksApi extends runtime.BaseAPI implements WebhooksApiInterface {

    /**
     */
    async getDealPipedriveContextRaw(requestParameters: GetDealPipedriveContextRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        if (requestParameters.isShared !== undefined) {
            queryParameters['isShared'] = requestParameters.isShared;
        }

        if (requestParameters.resource !== undefined) {
            queryParameters['resource'] = requestParameters.resource;
        }

        if (requestParameters.selectedIds !== undefined) {
            queryParameters['selectedIds'] = requestParameters.selectedIds;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/api/v1/webhooks/pipedrive/deal/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getDealPipedriveContext(requestParameters: GetDealPipedriveContextRequest): Promise<string> {
        const response = await this.getDealPipedriveContextRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getPersonPipedriveContextRaw(requestParameters: GetPersonPipedriveContextRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        if (requestParameters.isShared !== undefined) {
            queryParameters['isShared'] = requestParameters.isShared;
        }

        if (requestParameters.resource !== undefined) {
            queryParameters['resource'] = requestParameters.resource;
        }

        if (requestParameters.selectedIds !== undefined) {
            queryParameters['selectedIds'] = requestParameters.selectedIds;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/api/v1/webhooks/pipedrive/person/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getPersonPipedriveContext(requestParameters: GetPersonPipedriveContextRequest): Promise<string> {
        const response = await this.getPersonPipedriveContextRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async logPipedrivePersonAddedRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/api/v1/webhooks/pipedrive/person/added/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async logPipedrivePersonAdded(): Promise<string> {
        const response = await this.logPipedrivePersonAddedRaw();
        return await response.value();
    }

    /**
     */
    async logPipedrivePersonDeletedRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/api/v1/webhooks/pipedrive/person/deleted/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async logPipedrivePersonDeleted(): Promise<string> {
        const response = await this.logPipedrivePersonDeletedRaw();
        return await response.value();
    }

    /**
     */
    async logPipedrivePersonMergedRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/api/v1/webhooks/pipedrive/person/merged/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async logPipedrivePersonMerged(): Promise<string> {
        const response = await this.logPipedrivePersonMergedRaw();
        return await response.value();
    }

    /**
     */
    async logPipedrivePersonUpdatedRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/api/v1/webhooks/pipedrive/person/updated/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async logPipedrivePersonUpdated(): Promise<string> {
        const response = await this.logPipedrivePersonUpdatedRaw();
        return await response.value();
    }

}
